import { useDispatch, useSelector } from "react-redux";
import {
  COMPANY,
  PROJECT,
  TIMELAPSE,
  TLVIDEO,
  TLVIDEOALL,
  SENDEMAIL,
} from "../../services/actions";
import React from "react";
import ImageCard from "../extra/ImageCard";
import {
  Box,
  Grid,
  Button,
  Container,
  Typography,
  Popper,
  Pagination,
} from "@mui/material";
import RDialog from "../extra/RDialog";
import Form from "./Form";
import VideoPlayer from "../extra/VideoPlayer";
import ShareBox from "../extra/ShareBox";
import { BsEnvelope, BsXCircle } from "react-icons/bs";
import { useForm } from "react-hook-form";
import { useState } from "react";

export default function Timelapse() {
  const dispatch = useDispatch();
  const projectState = useSelector((state) => state?.projectState);
  const companyState = useSelector((state) => state?.companyState);
  const timelapseState = useSelector((state) => state?.timelapseState);
  const tlvideoallState = useSelector((state) => state?.tlvideoallState);
  const tlvideoState = useSelector((state) => state?.tlvideoState);
  // const user = useSelector((state) => state?.loginState?.auth);

  const [companies, setCompanies] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  // const [openShare, setOpenShare] = React.useState(false);
  const [openVideo, setOpenVideo] = React.useState(null);
  const [defV, setDefV] = React.useState({});
  const [view, setView] = React.useState(1); // 1: completed, 2: processing, 3: queue
  const [anchorEl, setAnchorEl] = React.useState(null);
  // const { handleSubmit, control, reset } = useForm({
  //   defaultValues: {},
  //   mode: "all",
  // });
  const [page, setPage] = React.useState(0); // current page
  const pageSize = 20; // number of items per page (your API seems to default to 20)

  const fetchTLVideos = (page = 1) => {
    let currentview = "completed";
    if (view === 2) currentview = "processing";
    if (view === 3) currentview = "queue";
    const url = page === 0 ? `tlvideo/${page}/` : `tlvideo/?page=${page}&filter_by={"status":"${currentview}"}`; // pass page number
    dispatch({ type: `${TLVIDEOALL}_GET`, payload: url });
  };

  // const getUrl = (actions, action_type) => {
  //   let url = "";
  //   (actions ?? []).forEach((action) => {
  //     if (action.action === action_type) {
  //       url = action.action_url;
  //     }
  //   });
  //   return url;
  // };
  // const [selectedImage, setSelectedImage] = useState("");
  React.useEffect(() => {
    try {
      dispatch({ type: `${COMPANY}_GET`, payload: 0 });
      //dispatch({ type: `${TLVIDEOALL}_GET`, payload: 0 });
      fetchTLVideos(1);
    } catch (err) { }
  }, []);

  React.useEffect(() => {
    fetchTLVideos(page);
  }, [page]);

  React.useEffect(() => {
    setCompanies(companyState?.data?.results);
  }, [companyState?.data]);

  React.useEffect(() => {
    console.log("VIDEO REQUESTed", tlvideoState);
    if (tlvideoState?.success) {
      setOpen(false);
      //dispatch({ type: `${TLVIDEOALL}_GET`, payload: 0 });
      fetchTLVideos(1);
    }
  }, [tlvideoState?.data]);

  React.useEffect(() => {
    //dispatch({ type: `${TLVIDEOALL}_GET`, payload: 0 });
    fetchTLVideos(1);
  }, [view]);

  return (
    <>
      <Popper
        placement="right-start"
        sx={{ zIndex: 99999, borderRadius: 2 }}
        open={Boolean(anchorEl?.target)}
        anchorEl={anchorEl?.target}
      >
        <Box sx={{ background: "#e3e3e3", borderRadius: 2 }}>
          <Box
            textAlign={"right"}
            sx={{ position: "absolute", width: 1, p: 1 }}
          >
            <BsXCircle onClick={() => setAnchorEl(null)} />
          </Box>
          <ShareBox
            activeView={0}
            let
            url={(anchorEl?.data?.video_urls || [1])[0]}
            subject={anchorEl?.data.name}
            description={`${anchorEl?.data.date_from} - ${anchorEl?.data.date_from}`}
            //camera={anchorEl?.data.camera}

            icons={[
              <Typography
                display={"flex"}
                gap={2}
                alignItems={"center"}
                fontSize={12}
              >
                <BsEnvelope fontSize={16} />
                Email
              </Typography>,
              <Typography
                display={"flex"}
                gap={2}
                alignItems={"center"}
                fontSize={12}
              >
                <BsEnvelope fontSize={16} />
                Schedule Email
              </Typography>,
              <Typography
                display={"flex"}
                gap={2}
                alignItems={"center"}
                fontSize={12}
              >
                <BsEnvelope fontSize={16} />
                Download Image
              </Typography>,
              <Typography
                display={"flex"}
                gap={2}
                alignItems={"center"}
                fontSize={12}
              >
                <BsEnvelope fontSize={16} />
                Download Image with timestamp
              </Typography>,
              <Typography
                display={"flex"}
                gap={2}
                alignItems={"center"}
                fontSize={12}
              >
                <BsEnvelope fontSize={16} />
                Print
              </Typography>,
              <Typography
                display={"flex"}
                gap={2}
                alignItems={"center"}
                fontSize={12}
              >
                <BsEnvelope fontSize={16} />
                MarkUp
              </Typography>,
            ]}
            onSubmit={(data) => {
              data["camera"] = anchorEl?.data.camera;
              data["video_urls"] = anchorEl?.data.video_urls[0];
              dispatch({ type: SENDEMAIL + "_POST", payload: data });
            }}
          />
        </Box>
      </Popper>

      {/* Video Dialog */}
      <RDialog
        fullScreen
        title="Timelapse"
        open={openVideo}
        handleClose={() => setOpenVideo(false)}
      >
        <VideoPlayer data={openVideo} />
      </RDialog>

      {/* Form Dialog */}

      {open ? (
        <Form
          companies={companies}
          projects={projectState?.data?.results}
          cameras={timelapseState?.data?.results}
          defaultValues={defV}
          onSubmit={(data) => {
            // data.status = !data.id?"queue":data.status
            const ACTION = data.id ? `${TLVIDEO}_PATCH` : `${TLVIDEO}_POST`;
            dispatch({ type: ACTION, payload: data });
          }}
          onChange={(action, value) => {
            if (value) {
              if (action === "project") {
                dispatch({
                  type: `${TIMELAPSE}_GET`,
                  payload: `timelapse/0/?filter_by={"project":"${value}"}`,
                });
              } else {
                dispatch({
                  type: `${PROJECT}_GET`,
                  payload: `project/0/?filter_by={"company":"${value}"}`,
                });
              }
            }
          }}
          back={() => {
            setOpen(false);
          }}
        />
      ) : (
        <Container maxWidth="xl" sx={{ py: 2 }}>
          {/* Add Button */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
            <Button
              className="btn-primary"
              sx={{ borderRadius: 3, py: 3 }}
              onClick={() => {
                setOpen(true);
                setDefV({});
              }}
            >
              + Add Image Timelapse
            </Button>
          </Box>

          {/* View Tabs */}
          <Box
            sx={{
              fontSize: 14,
              color: "white",
              display: "flex",
              mb: 3,
              gap: 1,
              background: "#e2e1e1ff",
              borderRadius: 8,
              p: 0.5,
            }}
          >
            <Button
              onClick={() => setView(1)}
              className={view === 1 ? "btn-primary" : ""}
              sx={{ flex: 1, borderRadius: '24px !important', fontSize: 10, color: "black !important" }}
            >
              Completed
            </Button>
            <Button
              onClick={() => setView(2)}
              className={view === 2 ? "btn-primary" : ""}
              sx={{ flex: 1, borderRadius: '24px !important', fontSize: 10, color: "black !important" }}
            >
              Processing
            </Button>
            <Button
              onClick={() => setView(3)}
              className={view === 3 ? "btn-primary" : ""}
              sx={{ flex: 1, borderRadius: '24px !important', fontSize: 10, color: "black !important" }}
            >
              Queue
            </Button>
          </Box>

          {/* Image Cards */}
          <Grid container spacing={1}>
            {tlvideoallState?.data?.results.map((d) => {
              const isQueue =
                (d.status === "" || d.status === "queue") && view === 3;
              const isProcessing = d.status === "processing" && view === 2;
              const isCompleted = d.status === "completed" && view === 1;
              let progreess = d.progress;

              if (isQueue || isProcessing || isCompleted) {
                return (
                  <Grid size={{ xs: 12, sm: 6, md: 4 }} key={d.id}>
                    <ImageCard
                      progress={progreess}
                      url={d.thumbnail}
                      label={
                        <>
                          <span style={{ color: "#E0B721" }}>
                            {d.camera_name}
                          </span>
                        </>
                      }
                      labelname={d.name}
                      data={d}
                      onClick={() => setOpenVideo(d)}
                      onAction={(action, data, e, url) => {
                        if (action == "Delete") {
                          dispatch({
                            type: `${TLVIDEO}_DELETE`,
                            payload: data?.id,
                          });
                        }
                        if (action == "Share") {
                          setAnchorEl({ target: e.currentTarget, data: data });
                        }
                      }}
                    />
                  </Grid>
                );
              }
              return null;
            })}
          </Grid>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Pagination
              count={Math.ceil(tlvideoallState?.data?.count / pageSize)}
              page={page}
              onChange={(e, value) => setPage(value)}
              color="primary"
            />
          </Box>
        </Container>
      )}
    </>
  );
}
